export class BookOfMindQuote {
    constructor(
        readonly quote: string,
        readonly parent: string,
        readonly id: number,
        readonly lastmodifiedtime: string
    ) {}

    Contains(text: string) {
        const lowerCaseText = text.toLowerCase();

        return (
            this.quote.toLowerCase().includes(lowerCaseText) ||
            this.parent.toLowerCase().includes(lowerCaseText)
        );
    }
}
